export const ErrorMessage = {
    'ja-JP': {
        'UserNotFoundException': "ユーザが存在しません",
        'CodeDeliveryFailureException': "認証コードの送信に失敗しました",
        'InvalidEmailRoleAccessPolicyException': "認証コードの送信に失敗しました",
        'InvalidSmsRoleTrustRelationException': "認証コードの送信に失敗しました",
        'InvalidParameterException': "入力項目が不足しています",
        'InvalidPasswordException': "パスワードが不正です",
        'NotAuthorizedException': "メールアドレスまたはパスワードが間違っています",
        'UsernameExistsException': "すでにメールアドレスは使われています",
        'UserNotConfirmedException': "認証コードの検証が完了していません",
        'PasswordResetException': "パスワードのリセットが必要です",
        'CodeMismatchException': "認証コードが一致しません。登録メールアドレスに届いている一番新しい認証コードをご入力ください。",
        'LimitExceededException': "試行回数の上限に達しました",
        'ExpiredCodeException': "認証コードが期限切れです。「認証コードを再送する」をクリックして認証コードを再発行してください。",
        'OtherException': "エラーが発生しました",
        'Timeout error': "ログインの有効期間が切れました",
        'Transfer msg': "マイページへ接続中",
        'Transfer info_msg': 'マイページへ接続中です もうしばらくお待ちください',
        'Back to Sign In on not transfering mypage': '画面が進まない場合はこちら'
    },
    'en-US': {
        'UserNotFoundException': "Incorrect email or password.",
        'CodeDeliveryFailureException': "The delivery of verification code is failed.",
        'InvalidEmailRoleAccessPolicyException': "The delivery of verification code is failed.",
        'InvalidSmsRoleTrustRelationException': "The delivery of verification code is failed.",
        'InvalidParameterException': "Required items are not completed",
        'InvalidPasswordException': "Password did not conform with policy.",
        'NotAuthorizedException': "Incorrect email or password.",
        'UsernameExistsException': "An account with the given email already exists.",
        'UserNotConfirmedException': "Verification code has not confirmed yet.",
        'PasswordResetException': "Please reset your password.",
        'CodeMismatchException': "Invalid verification code provided, please enter the latest verification code that has been sent to your registered email address.",
        'LimitExceededException': "Verification code has reached the limit",
        'ExpiredCodeException': "Verification code is expired, please click 'Resend authentication code' to reissue the verification code.",
        'OtherException': "An error is encountered.",
    }
}
